// Style
import style from "./info-card.module.scss";

// Components
import AbaIcon from "@/components/aba-icon/aba-icon";
// import TermButton from "../term-button/term-button";

export default function InfoCard(props) {
  //   let info = {
  //     {cardType: 'aka'},
  //   }

  let content = props.data;

  // IF USED, REFACTOR LIKE reg-agency.js TO REMOVE renderToString()
  // if (props.addInfo) {
  //   content = "<ul>";
  //   props.data?.nodes?.map((faq, i) => {
  //     content +=
  //       "<li>" +
  //       faq.title +
  //       renderToString(<TermButton term={faq.title} />) +
  //       "</li>";
  //   });
  //   content += "</ul>";
  // }

  return (
    <div className={style.itemContainer} style={{ borderColor: props.color }}>
      <div className={style.itemLabel} style={{ backgroundColor: props.color }}>
        <h2>{props.label}</h2>
        {props.icon && (
          <div>
            <AbaIcon name={AbaIcon.LIST[props.icon]} color="#fff" />
          </div>
        )}
      </div>
      <div
        className={style.itemContent}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}
